import ExpansionArrow from './ExpansionArrow';

export default ExpansionArrow;
